import {
  FilterType,
  buildBudgetMovementsDatatableFilter,
  useBudgetMovementsDatatable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  source: ReturnType<typeof useBudgetMovementsDatatable>
}

const StatusFilter = ({ source }: Props) => {
  const options = [
    {
      label: i18n.t('expenses_v2.list.filters.draft'),
      value: 'draft',
    },
    {
      label: i18n.t('expenses_v2.list.filters.reversed'),
      value: 'reversed',
    },
    {
      label: i18n.t('expenses_v2.list.filters.pending'),
      value: 'pending',
    },
    {
      label: i18n.t('expenses_v2.list.filters.approved'),
      value: 'approved',
    },
    {
      label: i18n.t('expenses_v2.list.filters.rejected'),
      value: 'rejected',
    },
    {
      label: i18n.t('expenses_v2.list.filters.in_payroll'),
      value: 'in_payroll',
    },
    {
      label: i18n.t('expenses_v2.list.filters.sent_to_pay'),
      value: 'sent_to_pay',
    },
    {
      label: i18n.t('expenses_v2.expense.status.paid'),
      value: 'paid',
    },
  ]

  return buildBudgetMovementsDatatableFilter(source, {
    path: 'expensableStatus',
    identifier: 'budgetMovements.expensableStatus',
    type: FilterType.String,
    title: i18n.t('budgets.detail.tabs.spendings.table.filters.status'),
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    default: true,
  })
}

export default StatusFilter
